/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/', {
      templateUrl: require('./frontpage.template.html'),
      title: 'Startseite',
    });
}
